/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';
import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Typography, Tooltip, Popover, Paper, Button, List, ListItem, ListItemText, Divider, ListItemSecondaryAction, Checkbox, CircularProgress, ListSubheader, Avatar } from '@material-ui/core'
import { FilterList, Close } from '@material-ui/icons'

import Action from '../../../../fluid/Actions/ActionFactory'
import { getUserPreferences, setUserPreferences } from '../../../UserController/UserPreferences'

const clone = require('rfdc')()
let equal = require('deep-equal')

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
    //   maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
}))(Tooltip);

const styles = theme => ({

})

class RecoFilter extends Component {
    state = {
        open : false,
        anchorEl : null,
        loading_ic_detail : false,
        ic_detail : null,
        ic_error : false,
        applied_filter : null,
        temp_filter : null,
        selected_field : null,
        possible_values : []
    }
    
    filterButton = React.createRef()

    componentWillMount () {
        console.log("RecoFilter IC Object:", this.props.ic_object)
        let filter = this.props.filters.find(filter => filter.ic_name === this.props.ic_object.ic_name)
        this.setState({...this.state, applied_filter : filter, temp_filter : filter}, () => console.log("RecoFilter Mount State : ", this.state))
    }

    // componentDidUpdate (prevProps) {
    //     if (prevProps.ic_object.ic_name !== this.props.ic_object.ic_name) {
    //         console.log("IC Object Updated")
    //         let filter = this.props.filters.find(filter => filter.ic_name === this.props.ic_object.ic_name)
    //         this.setState({...this.state, applied_filter : filter, temp_filter : filter}, () => console.log("RecoFilter Mount State : ", this.state))
    //     }
    // }

    applyFilter = () => {
        let new_filter = clone(this.state.temp_filter)
        this.setState({...this.state, applied_filter : new_filter}, () => {
            this.props.apply_filter(this.state.temp_filter, this.props.ic_object.ic_name)
        })
    }

    isFilterSaved = () => {
        let user_preferences = getUserPreferences()
        let saved_filters = user_preferences.preferences.recommendation.saved_filters
        let saved_filter = saved_filters.find(filter => filter.ic_name === this.props.ic_object.ic_name)
        if (equal(saved_filter, this.state.applied_filter)) {
            return true
        } else {
            return false
        }
    }

    removeSavedFilter = () => {
        let user_preferences = getUserPreferences()
        let saved_filters = user_preferences.preferences.recommendation.saved_filters
        let saved_filter_index = saved_filters.findIndex(filter => filter.ic_name === this.props.ic_object.ic_name)
        saved_filters.splice(saved_filter_index, 1)
        setUserPreferences(user_preferences)
    }

    saveFilter = () => {
        let user_preferences = getUserPreferences()
        let saved_filters = user_preferences.preferences.recommendation.saved_filters
        let saved_filter_ic_index = saved_filters.findIndex(filter => filter.ic_name === this.props.ic_object.ic_name)
        if (saved_filter_ic_index === -1) {
            saved_filters.push(this.state.applied_filter)
        } else {
            saved_filters[saved_filter_ic_index] = this.state.applied_filter
        }
        setUserPreferences(user_preferences)
    }

    getListOfIUs = (ic_object) => {
        let iu_list = new Set()
        ic_object.response.result.map(record => {
            iu_list.add(record.iu_key.user_friendly_name)
        })

        return Array.from(iu_list)
    }

    getRawFields = (iu_name, ic_object) => {
        let fields = new Set()
        let filtered_records = ic_object.response.result.filter(record => record.iu_key.user_friendly_name === iu_name)
        filtered_records.map(record => {
            let raw_fields = record.raw_fields.fields.map(field => field.name)
            raw_fields.map(field => fields.add(field))
        })

        return Array.from(fields)
    }

    getICDetail = () => {
        this.setState({...this.state, loading_ic_detail : true}, () => {
            let iu_list = this.getListOfIUs(this.props.ic_object)
            let filters = iu_list.map(iu => {
                let iu_detail = {
                    iu_name : iu,
                    fields : []
                }

                let raw_fields = this.getRawFields(iu, this.props.ic_object)
                raw_fields.forEach(field => {
                    let field_detail = {
                        name : field,
                        allowed_values : []
                    }
                    iu_detail.fields.push(field_detail)
                })
                return iu_detail
            })

            let new_temp_filter = clone(this.state.temp_filter)
            new_temp_filter.filters = filters

            this.setState({...this.state, loading_ic_detail: false, ic_detail : this.props.ic_object, ic_error : false, temp_filter : new_temp_filter}, () => console.log("RecoFilter fields populated : ", this.state))
            // Action('http_request', {
            //     url : "/sainapse/information_channel/" + this.props.ic_name,
            //     method : "get",
            //     data : {}
            // }).then(res => {
            //     let ic_detail = res.data.result
            //     let filters = []
            //     ic_detail.information_units.map(iu => {
            //         if (iu.config_type === "Trainable") {
            //             let iu_detail = {
            //                 iu_name : iu.name,
            //                 fields : []
            //             }
            //             iu.fields_in_scope.map(field => {
            //                 let field_detail = {
            //                     name : field.name,
            //                     allowed_values : []
            //                 }
            //                 iu_detail.fields.push(field_detail)
            //             })
            //             filters.push(iu_detail)
            //         }
            //     })
            //     let new_temp_filter = clone(this.state.temp_filter)
            //     new_temp_filter.filters = filters

            //     this.setState({...this.state, loading_ic_detail: false, ic_detail : ic_detail, ic_error : false, temp_filter : new_temp_filter}, () => console.log("RecoFilter fields populated : ", this.state))
            // }).catch(err => {
            //     this.setState({...this.state, loading_ic_detail: false, ic_detail : null, ic_error : true})
            // })
        })
    }

    renderRawFields = () => {
        let fields = this.state.temp_filter.filters.map(iu => {
            return (
                <Fragment>
                    <ListSubheader style = {{backgroundColor : '#FFFFFF'}}>{iu.iu_name}</ListSubheader>
                    {iu.fields.map(field => {
                        return (
                            <>
                            <ListItem 
                                key = {iu.iu_name + "/" + field.name} 
                                button
                                onClick = {(event) => this.handleFieldClick(iu.iu_name + "/" + field.name)}
                                selected = {this.state.selected_field === iu.iu_name + "/" + field.name}
                            >
                                <ListItemText id={field.name} primary={field.name} />
                            </ListItem>
                            <Divider component="li" />
                            </>
                        )
                    })}
                </Fragment>
            )
        })

        return fields
    }

    renderFieldList = () => {
        if (this.state.temp_filter !== null) {
            if (this.state.ic_error === false) {
                if (this.state.ic_detail !== null) {
                    if (this.state.temp_filter.filters.length > 0) {
                        return (
                            <List>
                                {this.renderRawFields()}
                            </List>
                        )
                    } 
                } else if (this.state.loading_ic_detail) {
                    return (
                        <div style = {{width : '100%', height : '100%', display : 'flex', flexDirection: 'row', justifyContent : 'center', alignItems : 'center'}}>
                            <CircularProgress color = 'primary'/>
                        </div>
                    )
                } else {
                    this.getICDetail()
                }
            } else {
                return (
                    <div style = {{width : '100%', height : '100%', display : 'flex', flexDirection: 'row', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography variant = 'caption' color = 'secondary'>Error Loading IC details</Typography>
                    </div>
                )
            }
            // if (this.state.temp_filter.filters.length > 0) {
            //     return (
            //         <List>
            //             {this.renderRawFields()}
            //         </List>
            //     )
            // } else if (this.state.loading_ic_detail) {
            //     return (
            //         <div style = {{width : '100%', height : '100%', display : 'flex', flexDirection: 'row', justifyContent : 'center', alignItems : 'center'}}>
            //             <CircularProgress color = 'primary'/>
            //         </div>
            //     )   
            // } else {
            //     this.getICDetail()
            // }
        }
    }

    getPossibleValues = (iu_name, field_name) => {
        let possible_values_set = new Set()
        this.props.ic_object.response.result.map(record => {
            if (record.iu_key.user_friendly_name === iu_name) {
                possible_values_set.add(record.raw_fields.fields.find(field => field.name === field_name).value)
            }
        })
        let possible_values = Array.from(possible_values_set)
        return possible_values
    }

    handleFieldClick = (list_key) => {
        let list_key_name = list_key.split("/")
        let iu_name = list_key_name[0]
        let field_name = list_key_name[1]
        let possible_values = this.getPossibleValues(iu_name, field_name)
        this.setState({...this.state, selected_field : list_key, possible_values : possible_values})
    }

    handleCheckBox = (value) => {
        let iu_name = this.state.selected_field.split("/")[0]
        let field_name = this.state.selected_field.split("/")[1]

        let new_temp_filter = clone(this.state.temp_filter)
        let iu_filter_index = new_temp_filter.filters.findIndex(filter => filter.iu_name === iu_name)
        let fields = new_temp_filter.filters[iu_filter_index].fields
        let field_index = fields.findIndex(field => field.name === field_name)

        if (new_temp_filter.filters[iu_filter_index].fields[field_index].allowed_values.includes(value)) {
            let value_index = new_temp_filter.filters[iu_filter_index].fields[field_index].allowed_values.findIndex(val => val === value)
            new_temp_filter.filters[iu_filter_index].fields[field_index].allowed_values.splice(value_index, 1)
        } else {
            new_temp_filter.filters[iu_filter_index].fields[field_index].allowed_values.push(value)
        }

        this.setState({...this.state, temp_filter : new_temp_filter}, () => console.log("RecoFilter Filter upated :", this.state ))
    }

    isValueAllowed = (value) => {
        let iu_name = this.state.selected_field.split("/")[0]
        let field_name = this.state.selected_field.split("/")[1]

        let new_temp_filter = clone(this.state.temp_filter)
        let iu_filter_index = new_temp_filter.filters.findIndex(filter => filter.iu_name === iu_name)
        let fields = new_temp_filter.filters[iu_filter_index].fields
        let field_index = fields.findIndex(field => field.name === field_name)

        if (new_temp_filter.filters[iu_filter_index].fields[field_index].allowed_values.includes(value)) {
            return true
        } else {
            return false
        }
    }

    renderPossibleValuesList = () => {
        if (this.state.possible_values.length > 0) {
            return (
                <List>
                    {this.state.possible_values.map(value => {
                        return (
                            <>
                            <ListItem 
                                key = {value} 
                            >
                                <ListItemText 
                                    id={value} 
                                    primary={value}
                                    primaryTypographyProps = {{noWrap : true}} 
                                />
                                <ListItemSecondaryAction>
                                    <Checkbox
                                        edge="end"
                                        checked = {this.isValueAllowed(value)}
                                        onChange = {() => this.handleCheckBox(value)}
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            <Divider component="li" />
                            </>
                        )
                    })}
                </List>
            )
        }
    }

    toggleAllPossibleValues = () => {
        let iu_name = this.state.selected_field.split("/")[0]
        let field_name = this.state.selected_field.split("/")[1]

        let new_temp_filter = clone(this.state.temp_filter)
        let iu_filter_index = new_temp_filter.filters.findIndex(filter => filter.iu_name === iu_name)
        let fields = new_temp_filter.filters[iu_filter_index].fields
        let field_index = fields.findIndex(field => field.name === field_name)

        if (new_temp_filter.filters[iu_filter_index].fields[field_index].allowed_values.length > 1) {
            new_temp_filter.filters[iu_filter_index].fields[field_index].allowed_values = []
        } else {
            new_temp_filter.filters[iu_filter_index].fields[field_index].allowed_values = [...this.state.possible_values]
        }

        this.setState({...this.state, temp_filter : new_temp_filter}, () => console.log("RecoFilter Filter upated :", this.state ))
    }

    isAllValuesSelected = () => {
        if (this.state.selected_field !== null) {
            let iu_name = this.state.selected_field.split("/")[0]
            let field_name = this.state.selected_field.split("/")[1]

            let new_temp_filter = clone(this.state.temp_filter)
            let iu_filter_index = new_temp_filter.filters.findIndex(filter => filter.iu_name === iu_name)
            let fields = new_temp_filter.filters[iu_filter_index].fields
            let field_index = fields.findIndex(field => field.name === field_name)

            if (new_temp_filter.filters[iu_filter_index].fields[field_index].allowed_values.length === this.state.possible_values.length) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    }

    renderFilterList = () => {
        return (
            <Fragment>
                <div style = {{width : '50%', maxHeight : '100%', display : 'flex', flexDirection : 'column', borderRight : '1px solid rgba(0,0,0,0.12)'}}>
                    <Paper square style = {{width : '100%', height : '30px', display : 'flex', flexDirection : 'row', alignItems : 'center', padding : '10px'}}>
                        <Typography variant = 'subtitle2'>Fields</Typography>
                    </Paper>
                    <div style = {{width : '100%', height : 'calc(50vh - 130px)', overflow : 'auto'}}>
                        {this.renderFieldList()}
                    </div>
                </div>
                <div style = {{width : '50%', maxHeight : '100%', display : 'flex', flexDirection : 'column'}}>
                    <Paper square style = {{width : '100%', height : '30px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                        <Typography style = {{flexGrow : 1, marginleft : '10px'}} variant = 'subtitle2'>Possible Values</Typography>
                        <Checkbox
                            checked={this.isAllValuesSelected()}
                            onChange={this.toggleAllPossibleValues}
                        />
                    </Paper>
                    <div style = {{width : '100%', height : 'calc(50vh - 130px)', overflow : 'auto'}}>
                        {this.renderPossibleValuesList()}
                    </div>
                </div>
            </Fragment>
        )
    }

    closePopover = () => {
        this.setState({...this.state, open : false, anchorEl : null})
    }

    openPopover = (event) => {
        this.setState({...this.state, open : true, anchorEl : event.currentTarget}, () => console.log("Sort State : ", this.state))
    }

    renderFilterPopover = () => {
        return (
            <Popover
                id = {"filter_list"}
                open = {this.state.open}
                anchorEl={this.state.anchorEl}
                onClose={this.closePopover}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps = {{
                    square : true,
                    elevation : 8,
                    style : {
                        margin : 0,
                        padidng : 0
                    }
                }}
            >
                <div style = {{
                    width : '50vw',
                    height : '50vh',
                    display : 'flex',
                    flexDirection : 'column'
                }}>
                    <Paper 
                    square
                    elevation = {2}
                    style = {{
                        width : '100%', 
                        height : '50px', 
                        display : 'flex', 
                        flexDirection : 'row',
                        alignItems : 'center',
                        backgroundColor : "#2296f3",
                        padding : '10px'
                    }}>
                        <div style = {{flexGrow : 1, display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                            <FilterList 
                                style = {{
                                    color : "#FFFFFF",
                                    marginRight : '5px'
                                }} 
                                size = "small"
                            />
                            <Typography style = {{color : "#FFFFFF"}} variant = "subtitle2">Filter Settings</Typography>
                        </div>
                        <Tooltip title = "Close">
                            <Close style = {{color : "#FFFFFF", cursor : "pointer"}} fontSize = "small" onClick = {this.closePopover}/>
                        </Tooltip>
                    </Paper>
                    <div style = {{width : '100%', flexGrow : 1, display : 'flex', flexDirection : 'row'}}>
                        {this.renderFilterList()}
                    </div>
                    <div 
                    style = {{
                        width : '100%', 
                        height : '50px', 
                        display : 'flex', 
                        flexDirection : 'row-reverse', 
                        alignItems : 'center', 
                        borderTop : '1px solid rgba(0,0,0,0.12)'
                    }}
                    >
                        <Button 
                            style = {{marginRight : '10px'}} 
                            color = "primary" 
                            size = "small"
                            disabled = {equal(this.state.applied_filter, this.state.temp_filter)}
                            onClick = {this.applyFilter}
                        >Apply Filter</Button>
                        {this.isFilterSaved() ? 
                            <Tooltip title = "Remove this filter setting for this IC. This setting will not be auto applied in the future.">
                                <Button 
                                    color = "secondary" 
                                    size = "small"
                                    disabled = {!equal(this.state.applied_filter, this.state.temp_filter)}
                                    onClick = {this.removeSavedFilter}
                                >Do Not Apply in the future</Button>
                            </Tooltip>
                            :
                            <Tooltip title = "Saves this filter setting for this IC and auto applis while querying this IC in the future.">
                                <Button 
                                    color = "primary" 
                                    size = "small"
                                    disabled = {!equal(this.state.applied_filter, this.state.temp_filter)}
                                    onClick = {this.saveFilter}
                                >Auto Apply in the future</Button>
                            </Tooltip>
                        }
                        
                    </div>
                </div>
            </Popover>
        )
    }

    getFiltersApplied = () => {
        let filters_applied = this.state.applied_filter.filters.map(iu_filter => {
            let iu_applied = iu_filter.fields.filter(field => field.allowed_values.length > 0)
            let iu = {
                name : iu_filter.iu_name,
                applied : iu_applied
            }
            return iu
        })
        
        filters_applied.filter(filter => filter.applied.length > 0)
        console.log("Filters Applied RecoFilter : ", filters_applied)
        return filters_applied
    }

    render() { 
        const { classes } = this.props
        return (
            <Fragment>
                <div
                    ref = {this.filterButton}
                    onClick = {this.openPopover}
                    style = {{
                        width : '100%', 
                        height : '100%',
                        padding : '5px',
                        display : 'flex',
                        flexDirection : 'row',
                        alignItems : 'center',
                        cursor: 'pointer',
                        backgroundColor : this.state.open ? "#2296f3" : null
                    }}
                >
                    <div style = {{
                        flexGrow : 1,
                        display : 'flex',
                        flexDirection : 'row',
                        alignItems : 'center'
                    }}>
                        <Tooltip title = "Filter">
                            <FilterList 
                                style = {{
                                    color : this.state.open ? "#FFFFFF" : "rgba(0,0,0,0.75)"
                                }} 
                                size = "small"
                            />
                        </Tooltip>
                        <Typography style = {{margin : '5px', color : this.state.open ? "#FFFFFF" : "rgba(0,0,0,0.8)"}} variant = 'subtitle2'>Filter</Typography>
                    </div>
                    <div 
                        style = {{
                            display : 'flex',
                            flexDirection : 'row',
                            alignItems : 'center',
                            justifyContent : 'flex-end'
                        }}
                    >
                        {this.getFiltersApplied().length > 0 ? <HtmlTooltip 
                        title = {
                            <div>
                                <div style = {{width  : '10vw'}}>
                                    <div style = {{width  : '100%', padding : '5px', display : 'flex', flexDirection : 'column', borderBottom : '1px solid rgba(0,0,0,0.12)'}}>
                                        <Typography variant = 'caption' color = "textSecondary">Filter Applied on Fields</Typography>
                                    </div>
                                    {this.getFiltersApplied().map(filter => {
                                        return filter.applied.map(field => {
                                            return (
                                                <div style = {{width  : '100%', padding : '5px', display : 'flex', flexDirection : 'column'}}>
                                                    <Typography style = {{flexGrow : 1}} variant = 'body2'>Field: {field.name}</Typography>
                                                    <Typography variant = 'caption' color = "textSecondary">IU: {filter.name}</Typography>
                                                </div>
                                            )
                                        })
                                    })}
                                </div>
                            </div>
                        }>
                            <Avatar style = {{width : '30px', height : "30px", backgroundColor : "#2296f3"}}>
                                <FilterList size = "small" style = {{color : "#FFFFFF"}} />
                            </Avatar>
                        </HtmlTooltip> : null}
                    </div>
                </div>
                {this.renderFilterPopover()}
            </Fragment>
        );
    }
}
 
export default withStyles(styles)(RecoFilter);